"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDataType = void 0;
var FilterDataType;
(function (FilterDataType) {
    FilterDataType["String"] = "string";
    FilterDataType["Numeric"] = "numeric";
    FilterDataType["Date"] = "date";
    FilterDataType["Datetime"] = "datetime";
})(FilterDataType = exports.FilterDataType || (exports.FilterDataType = {}));
